<template>
	<div style="background-color: #F1F2F3;height: 100vh;">
		<van-cell style="padding: 20px 20px 10px 20px; background-color: #FFFFFF;">
			<content-item contentLeft="发票金额"  :contentRight="amount + '元'"  :border="false" ></content-item>
			<content-item contentLeft="交存业务编号" :contentRight="reqNo"></content-item>
		</van-cell>
<!--		<div v-if="showError" style="margin:20px auto; width:50%;" class="uni-flex">-->
<!--			<van-button text="刷新" size="small" shape="circle" type="primary" @click="allRequest('ticket')"></van-button>-->
<!--		</div>-->
		<div v-if="imageBase64!==''&&!showError" style="text-align: center;">
      <van-button type="info" round @click="toCheck()">查看电子票</van-button>
<!--			<van-image style="width:100%; margin: 5px auto;" mode="aspectFit" :src="imageBase64"></van-image>-->
<!--      <van-cell >-->
<!--        <van-button text="下载" size="small" round  type="primary" style="margin-left: 3%;  background-color: #568AFC" @click.native="download()"></van-button>-->
<!--        <van-button text="发送至邮箱" size="small" round  style="background-color: #568AFC; margin-left: 15%;" type="primary" @click="show=true"></van-button>-->
<!--        <van-button text="自助打印二维码" size="small" round  style="background-color: #568AFC; margin-left: 15%;" type="primary" @click="selectImageWeChat"></van-button>-->
<!--      </van-cell>-->
		</div>
    <div v-if="imageBase64==''||showError" class="text-div">
      <span style="color: #E43D33">对不起，此笔业务的发票尚未开具</span>
    </div>
<!--		<div v-if="imageBase64===''&&!showError">-->
<!--      <div style="margin:20px 20px 15px 20px; background-color: #FFFFFF; padding-top: 5px; padding-bottom: 5px;">-->
<!--        <van-field v-model="value" name="email" label="" placeholder="请输入您的邮箱" clearable border :center="true"-->
<!--                   input-align="center" style="width: 90%;margin:0 auto"/>-->
<!--      </div>-->
<!--      <div style="margin-left: 40px;margin-right: 40px;">-->
<!--				<span style="color: #333333;font-size: 15px;">-->
<!--					也可预留您的邮箱地址，一旦开具完成，将会发送至您的邮箱，请注意查收-->
<!--				</span>-->
<!--      </div>-->
<!--      <van-cell class="operate">-->
<!--        <van-button text="提交" type="info" round style="width: 100%" @click="allRequest('saveEmail')"></van-button>-->
<!--      </van-cell>-->
<!--    </div>-->
<!--    <van-popup v-model="show" closeable  :style="{width:'100%', height:'100%'}">-->
<!--      <van-form>-->
<!--        <van-field v-model="email" name="email" label="" placeholder="请输入您的邮箱" clearable border :center="true" input-align="center" style="width: 90%;margin:0 auto"  />-->
<!--        <van-cell class="operate">-->
<!--          <van-button text="提交" type="info" round style="width: 100%" @click="allRequest('email')"></van-button>-->
<!--        </van-cell>-->
<!--      </van-form>-->
<!--    </van-popup>-->
<!--    <van-popup v-model="showWeChat" closeable :style="{width:'100%', height:'100%'}">-->
<!--      <van-image style="width:100%; margin: 5px auto;" mode="aspectFit" :src="weChatBase64"></van-image>-->
<!--      <p style="margin: 5px 20px;">-->
<!--					可自行打印纸质发票，也可凭此二维码在安平县市民服务中心24小时自助服务厅打印纸质票据。-->
<!--      </p>-->
<!--      <van-image style="width: 90%;margin-left: 5%; margin-top: 20px" :src="require('@/assets/ticket/ticketsec.jpg')"></van-image>-->
<!--      <van-image style="width: 90%;margin-left: 5%" :src="require('@/assets/ticket/ticketfir.jpg')"></van-image>-->
<!--    </van-popup>-->
  </div>
</template>

<script>
import {download, selectImageWeChat} from '@/api/maintainFund/deposit';
import ContentItem from '@/components/content-item.vue'

export default {
  components:{
    ContentItem,
  },
  data() {
    return {
      imageBase64: "",
      showError: false,
      reqNo: this.$route.query.reqNo,
      amount: this.$route.query.amount,
      value: "",
      email: "",
      houseGuid: this.$route.query.houseGuid,
      show: false,
      list: {},
      weChatBase64: '',
      showWeChat: false
    }
  },
  created() {
    this.allRequest("ticket")//获取电子票
  },
  methods:{
    toCheck() {
      window.location.href = this.imageBase64
    },
    download(){
      download({})
    },
    allRequest(types){
      let req = '';

      if(this.reqNo.indexOf("_") > 0 ){
        let kids = this.reqNo.split("_");
        req= kids[1];
      }else{
        req = this.reqNo
      }
      let house = '';

      if(this.houseGuid.indexOf("_") > 0 ){
        let kids = this.houseGuid.split("_");
        house= kids[1];
      }else{
        house = this.houseGuid
      }
      if(types === "ticket"){
        this.list = {
          type :types,
          keyId:req,
          cityCode:'150400',
          houseGuid:house
        }
      }
      else if(types === "email"){
        this.list = {
          type :types,
          keyId:req,
          cityCode:'150400',
          houseGuid:house,
          email:this.email,
        }
      }

      download(this.list).then(res=>{
        if(res.data.code==="1"){
          if(types === "ticket"){
            this.showError = false;
            this.imageBase64 =  res.data.imgBase64;
            //this.imageBase64 =this.imageBase64.replace(/[\r\n]/g,"");
          }
          else if (types === "email"){
            this.show = false;
            this.$toast.success("电子票已发送至邮箱，请注意查收！");
            this.$router.push({path:"/billObtain/main"})
          }
        }else if (res.code === "0"){
          this.$toast.fail(res.msg);
        }
        else{
          if (types ==="ticket"){
            if(res.code==="2"){
              this.imageBase64="";
            }else{
              this.showError = true;
            }
          }
        }
      })
    },
    selectImageWeChat() {
      let req = '';
      if(this.reqNo.indexOf("_") > 0 ){
        let kids = this.reqNo.split("_");
        req= kids[1];
      }else{
        req = this.reqNo
      }
      let house = '';
      if(this.houseGuid.indexOf("_") > 0 ){
        let kids = this.houseGuid.split("_");
        house= kids[1];
      }else{
        house = this.houseGuid
      }
      let data = {
        keyId:req,
        cityCode:'131125',
        houseGuid:house
      }
      selectImageWeChat(data).then(res => {
        if(res.code==="1"){
          this.showError = false;
          this.weChatBase64 = res.url;
          this.weChatBase64 = this.weChatBase64.replace(/[\r\n]/g,"");
          this.showWeChat = true
        }else if (res.code === "0"){
          this.$toast.fail(res.msg);
        }
        else{
          if(res.code==="2"){
            this.weChatBase64="";
          }else{
            this.showError = true;
          }
        }
      })
    }
  }
}

</script>
<style>
	.text-div{
		width: 100%;
		text-align: center;
		padding-top: 40px;
		padding-bottom: 20px;
		background-color: #FFFFFF;
	}
</style>
